import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=75484252&scoped=true"
import script from "./Boleto.vue?vue&type=script&lang=js"
export * from "./Boleto.vue?vue&type=script&lang=js"
import style0 from "./Boleto.vue?vue&type=style&index=0&id=75484252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75484252",
  null
  
)

export default component.exports